//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileShower from '../component/file-shower';
import formPage from '../audit/form';
export default {
    components: { fileShower, formPage },
    props: {
        search: {
            type: Object,
            default: () => ({
                rowguid: '',
            }),
        },
    },
    computed: {
        pathSupply() {
            return /micromessenger/i.test(navigator.userAgent)
                ? '?mp.wexin.qq.com'
                : '';
        },
    },
    data() {
        return {
            form: {},
            dialogVisible: false,
            id: '',
            formSearch: {
                id: '',
            },
            filesrc: '',
            filename: '',
            isAudit: false,
            stepActive: 0,
            steps: [],
        };
    },
    methods: {
        auditClose() {
            this.goto('/bankguarantee/audit/list');
        },
        getData() {
            this.$get(
                this.getStore('bankguart') +
                    '/gua_order/' +
                    sessionStorage.getItem('id'),
                (data) => {
                    this.form = data.guaOrder;
                    this.steps = data.steps;
                    this.stepActive = data.active;
                }
            );
        },
        auditHandler() {
            this.formSearch.id = sessionStorage.getItem('id');
            this.dialogVisible = true;
        },
        fileClick(val) {
            this.filesrc = val.filesavepath + this.pathSupply;
            this.filename = val.fileoldname + '.' + val.filetype;
        },
    },
    mounted() {
        this.getData();
        this.isAudit = sessionStorage.getItem('type') == 'audit' ? true : false;
    },
};
